import React from 'react'
// components
import { DrawerModal } from 'components/UI'
// view components
import { ActionPreview, KPIPreview, ObjectivePreview } from './components/PlanItemPreview'
// hooks
import { useModalData } from 'hooks/index'
// constants
import { ENTITIES, Modals } from 'constants/index'

const PlanItemPreviewModal: React.FC = () => {
  const {
    hideModal,
    modalData: { isOpen, entity }
  } = useModalData({ modalType: Modals.PLAN_ITEM_PREVIEW_MODAL })

  const entityType = entity?.entityType

  return (
    <DrawerModal width={'600px'} isOpen={isOpen} hideModal={hideModal} sx={{ zIndex: 1301 }}>
      {entityType === ENTITIES.PLAN_OBJECTIVE && <ObjectivePreview entity={entity} hideModal={hideModal} />}
      {entityType === ENTITIES.PLAN_ACTION && <ActionPreview entity={entity} hideModal={hideModal} />}
      {entityType === ENTITIES.PLAN_KPI && <KPIPreview entity={entity} hideModal={hideModal} />}
    </DrawerModal>
  )
}

export default PlanItemPreviewModal
